import { render, staticRenderFns } from "./policiesContent.vue?vue&type=template&id=6ebf8ff2&scoped=true&"
var script = {}
import style0 from "./policiesContent.vue?vue&type=style&index=0&id=6ebf8ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf8ff2",
  null
  
)

export default component.exports